module.exports = __webpack_public_path__ + "img/main-bcg.7b4c431.webp";